export const formInputGroups = {
    "Personal Details": {
        group1: {
            alternateContact: {
                type: "phone"
            },
            dob: {
                type: "date"
            },
        },
        group2: {
            currentResidential: {
                type: "textarea"
            },
            permanentResidential: {
                type: "textarea"
            },
            city: {
                type: "text"
            },
            pin: {
                type: "number"
            }
        },
        group3: {
            language: {
                type: "text"
            },
            motherTongue: {
                type: "text"
            },
            familyMembers: {
                type: "number"
            },
            dependentFamilyMembers: {
                type: "number"
            }
        },
        group5: {
            gender: {
                type: "radio"
            },
        },
    },
    "University Details": {
        group1: {
            universityRegistrationNumber: {
                type: "text"
            },
            universitySeatNumber: {
                type: "text"
            },
        },
    },
    "Educational Qualification": {
        group1: {
            highestQualification: {
                type: "text"
            },
            stream: {
                type: "text"
            },
            collegeName: {
                type: "text"
            },
            percentage: {
                type: "text"
            },
            yearOfPassing: {
                type: "year"
            },
            educationSpecialization: {
                type: "text"
            },
        },
        group2: {
            twelfthPercentage: {
                type: "text"
            },
            twelfthYearOfPassing: {
                type: "year"
            },
        },
        group3: {
            tenthPercentage: {
                type: "text"
            },
            tenthYearOfPassing: {
                type: "year"
            },
        }
    },
    "Job Details": {
        group1: {
            workedInBank: {
                type: "radio"
            },
            verticalType: {
                type: "radio"
            },
            yearsOfExp: {
                type: "number"
            },
            compensation: {
                type: "number"
            },
            company: {
                type: "text"
            },
            noticePeriod: {
                type: "number"
            },
        },
        group2: {
            locationPreference: {
                type: "multi-select"
            }
        },
        group3: {
            edpId: {
                type: "text",
                tooltipText: `Please mention your  issued Godrej Employee ID (see your employee badge). If you do not have a Godrej Employee ID, please mention as N/A`
            },
        },
        group4: {
            zoneName: {
                type: "single-select"
            },
            site: {
                type: "single-select"
            },
        },
        group5: {
            productWorked: {
                type: "single-select"
            },
            ticketSize: {
                type: "single-select"
            },
            avgIncentive: {
                type: "single-select"
            },
            sourceOfHiring: {
                type: "text"
            },
            referral: {
                type: "text"
            },
            branchDistance: {
                type: "text"
            },
        },
    },
    "Upload Resume": {
        group1: {
            resumeUpload: {
                type: "file"
            }
        }
    }
}

export const initialValues = {
    alternateContact: "",
    dob: "",
    currentResidential: "",
    permanentResidential: "",
    gender: "",
    highestQualification: "",
    stream: "",
    collegeName: "",
    percentage: "",
    yearOfPassing: "",
    twelfthPercentage: "",
    twelfthYearOfPassing: "",
    tenthPercentage: "",
    tenthYearOfPassing: "",
    resumeUpload: "",
    universitySeatNumber: "",
    universityRegistrationNumber: "",
    language: "",
    yearsOfExp: "",
    compensation: "",
    locationPreference: "",
    edpId: "",
    zoneName: "",
    site: "",
    city: "",
    pin: "",
    company: "",
    noticePeriod: "",
    verticalType: "",
    productWorked: "",
    ticketSize: "",
    avgIncentive: "",
    workedInBank: "",
    sourceOfHiring: "",
    referral: "",
    branchDistance: "",
    educationSpecialization: "",
    familyMembers: "",
    dependentFamilyMembers: "",
    motherTongue: "",
}

export const acceptedFileTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]

const locationOptions = ["Mumbai", "Pune", "Chennai", "Bengaluru", "Hyderabad", "Coimbatore", "Kolkata"]

const zoneOptions = ["North", "South", "Mumbai/MMR", "West-East"]

const genderOptions = ["male", "female", "others", "dont_prefer"]

const verticalTypeOptions = ["secured", "unsecured"]

const productWorkedOptions = ["HL", "UBL", "LAP", "UCL", "PL", "SA.CA", "None"]

const ticketSizeOptions = ["Fresher", "50K and below", "50K - 2L", "2L - 5L", "5L - 10L", "10L and above"]

const incentiveOptions = ["Nil", "Less than 3k", "3k - 7k", "7k - 10k", "10k and above"]

const workedInBankOptions = ["yes", "no"]

export const dropdownInputOptions = {
    zoneName: zoneOptions,
    locationPreference: locationOptions,
    "North-site": [
        "ASHOK VIHAR",
        "FARIDABAD",
        "GODREJ AIR",
        "GODREJ ARIA/101",
        "GODREJ GOLF LINK",
        "GODREJ HABITAT",
        "GODREJ KURUKSHETRA",
        "GODREJ MERIDIEN",
        "GODREJ NATURE PLUS",
        "GODREJ NEST & NURTURE",
        "GODREJ PALM RETREAT",
        "GODREJ SECTOR 103",
        "GODREJ SECTOR 146",
        "GODREJ SECTOR 43 GGN",
        "GODREJ SECTOR 49",
        "GODREJ SECTOR 54",
        "GODREJ SECTOR 89",
        "GODREJ SOUTH ESTATE",
        "GODREJ SUMMIT",
        "GODREJ TDI",
        "GODREJ WOODS",
        "OASIS/ICON",
        "SONIPAT",
    ],
    "South-site": [
        "RGA TECH PARK",
        "GODREJ AVENUES",
        "BENGAL LAMPS",
        "GODREJ ROYALE WOODS",
        "GODREJ ETERNITY",
        "AGROVET",
        "BALGUR",
        "GODREJ NURTURE",
        "WHITEFIELD GARDEN CITY",
        "ORAGADAM",
        "KOKAPET",
        "VIBHUTHIPURA",
        "BANNERGHATA",
        "YESHWANTHPUR",
        "BEL HYDERABAD",
        "BANGALORE RO",
        "RGA 2",
        "GODREJ PARK RETREAT",
        "WOODSCAPE",
        "WOODLAND",
        "ANANDA",
        "ATHENA",
        "GODREJ ORAGADAM",
        "SPLENDOUR"
    ],
    "Mumbai/MMR-site": [
        "BHANDUP",
        "CARMICHAEL",
        "GODREJ ASCEND",
        "GODREJ AVENUE 11",
        "GODREJ BAYVIEW",
        "GODREJ CITY",
        "GODREJ EMERALD",
        "GODREJ EXQUISITE",
        "GODREJ FIVE GARDENS",
        "GODREJ HORIZON",
        "GODREJ NIRVAAN",
        "GODREJ PRIME",
        "GODREJ RESERVE",
        "GODREJ RIVIERA",
        "GODREJ RKS",
        "GODREJ SKY TERRACES",
        "GODREJ TRANQUIL",
        "GODREJ UPAVAN",
        "GODREJ URBAN PARK",
        "GODREJ VIHAA",
        "IMAGICA",
        "KHALAPUR",
        "MANOR"
    ],
    "West-East-site": [
        "GODREJ SECTOR 146",
        "GODREJ MERIDIEN",
        "GODREJ AIR",
        "GODREJ SUMMIT",
        "GODREJ NATURE PLUS",
        "GODREJ SECTOR 43 GGN",
        "SONIPAT",
        "GODREJ NEST & NURTURE",
        "GODREJ SOUTH ESTATE",
        "GODREJ KURUKSHETRA",
        "GODREJ SECTOR 49",
        "GODREJ SECTOR 103",
        "GODREJ HABITAT",
        "GODREJ SECTOR 89",
        "GODREJ TDI",
        "GODREJ GOLF LINK",
        "GODREJ PALM RETREAT",
        "GODREJ WOODS",
        "GODREJ ARIA/101",
        "ASHOK VIHAR",
        "GODREJ SECTOR 54",
        "FARIDABAD",
        "OASIS/ICON",
        "NAGPUR",
        "MAMURDI",
        "MAHALUNGE",
        "MANJARI",
        "GGC",
        "KP NX",
        "SE7EN",
        "ICC",
        "MAAN-HINJE",
        "PRAKRITI",
        "PUNE RO",
        "NAGPUR 2",
        "MUNDHWA",
        "BL SAHA",
        "MAAN HINJE",
        "ICC - PIMPRI",
        "MUNDHAWA",
        "ZO",
        "KP2",
        "KESHAVNAGAR",
    ],
    gender: genderOptions,
    verticalType: verticalTypeOptions,
    productWorked: productWorkedOptions,
    ticketSize: ticketSizeOptions,
    avgIncentive: incentiveOptions,
    workedInBank: workedInBankOptions,
}

export const dropdownInputMode = {
    zoneName: "single",
    site: "single",
    locationPreference: "multiple",
    gender: "single",
    verticalType: "single",
    productWorked: "multiple",
    ticketSize: "single",
    avgIncentive: "single",
    workedInBank: "single",
}